/*
* Constants.ts
* @author Abhilash Panwar (abpanwar)
* @copyright Microsoft 2020
* File containing constants for Engagement Insights properties.
*/
var _Extensions = /** @class */ (function () {
    function _Extensions() {
    }
    _Extensions._SignalExt = 's';
    _Extensions._SignalLongExt = 'signal';
    return _Extensions;
}());
export { _Extensions };
var _SignalExtKeys = /** @class */ (function () {
    function _SignalExtKeys() {
    }
    _SignalExtKeys._View = 'v';
    _SignalExtKeys._Referrer = 'r';
    _SignalExtKeys._Action = 't';
    _SignalExtKeys._Click = 'k';
    _SignalExtKeys._Session = 's';
    _SignalExtKeys._User = 'u';
    _SignalExtKeys._Host = 'h';
    _SignalExtKeys._Sdk = 'z';
    _SignalExtKeys._ExtKey = 'e';
    return _SignalExtKeys;
}());
export { _SignalExtKeys };
var _SharedKeys = /** @class */ (function () {
    function _SharedKeys() {
    }
    _SharedKeys._Type = 't';
    _SharedKeys._Uri = 'u';
    _SharedKeys._NameKey = 'n';
    _SharedKeys._Domain = 'd';
    _SharedKeys._Version = 'v';
    _SharedKeys._Title = 'v';
    _SharedKeys._Class = 'c';
    _SharedKeys._TimeZone = 'z';
    _SharedKeys._Source = 's';
    _SharedKeys._Id = 'i';
    return _SharedKeys;
}());
export { _SharedKeys };
var _UserExtKeys = /** @class */ (function () {
    function _UserExtKeys() {
    }
    _UserExtKeys._LocalId = 'd';
    _UserExtKeys._AuthId = 'a';
    _UserExtKeys._AuthType = 'u';
    _UserExtKeys._Email = 'e';
    _UserExtKeys._State = 's';
    _UserExtKeys._TimeSinceVisit = 't';
    return _UserExtKeys;
}());
export { _UserExtKeys };
var _ReferrerExtKeys = /** @class */ (function () {
    function _ReferrerExtKeys() {
    }
    _ReferrerExtKeys._PageTitle = 'p';
    return _ReferrerExtKeys;
}());
export { _ReferrerExtKeys };
var _ViewExtKeys = /** @class */ (function () {
    function _ViewExtKeys() {
    }
    _ViewExtKeys._Height = 'h';
    _ViewExtKeys._Width = 'w';
    _ViewExtKeys._VpHeight = 'g';
    _ViewExtKeys._VpWidth = 'd';
    _ViewExtKeys._ColorDepth = 'o';
    _ViewExtKeys._PreviousViews = 'r';
    _ViewExtKeys._SResolution = 's';
    return _ViewExtKeys;
}());
export { _ViewExtKeys };
var _ActionExtKeys = /** @class */ (function () {
    function _ActionExtKeys() {
    }
    _ActionExtKeys._ElapsedTime = 'e';
    _ActionExtKeys._IsOutbound = 'o';
    _ActionExtKeys._Target = 'g';
    _ActionExtKeys._ElementId = 'm';
    return _ActionExtKeys;
}());
export { _ActionExtKeys };
var _ClickExtKeys = /** @class */ (function () {
    function _ClickExtKeys() {
    }
    _ClickExtKeys._Coordinates = 'c';
    return _ClickExtKeys;
}());
export { _ClickExtKeys };
var _SessionExtKeys = /** @class */ (function () {
    function _SessionExtKeys() {
    }
    _SessionExtKeys._Id = 'i';
    _SessionExtKeys._Duration = 'd';
    return _SessionExtKeys;
}());
export { _SessionExtKeys };
var _UserStateValues = /** @class */ (function () {
    function _UserStateValues() {
    }
    _UserStateValues._New = 'new';
    _UserStateValues._Returning = 'returning';
    return _UserStateValues;
}());
export { _UserStateValues };
export var _ViewEventName = 'view';
export var _ViewSchemaVersion = '1.0';
export var _ActionEventName = 'action';
export var _ActionSchemaVersion = '1.0';
export var _SDKVersion = 'EI-JS-1.0.3';
export var _emptyString = '';
export var _PageViewType = 'page';
export var _EIPreviousKey = 'EISession.Previous';
export var _EISessionKey = 'EISession.Id';
export var _MSEI = '_msei';
export var _UserMappingEventName = 'usermapping';
export var _UserMappingEventVersion = '1.0';
export var _UserMappingStorageKey = 'EIMappings';
export var _DayToMilliseconds = 24 * 60 * 60 * 1000;
// stats related
export var _StatsEventName = 'ei_sdk_stats';
export var _StatsSchemaVersion = '1.0';
export var _eventSendRequest = 'e_sr';
export var _eventSent = 'e_s';
export var _eventDiscarded = 'e_d';
export var _eventDiscardedUnknown = 'e_d_u';
export var _eventDiscardedNonRetryableStatus = 'e_d_nr';
export var _eventDiscardedInvalidEvent = 'e_d_ie';
export var _eventDiscardedSizeLimitExceeded = 'e_d_sle';
export var _eventDiscardedKillSwitch = 'e_d_ks';
export var _eventDiscardedQueueFull = 'e_d_qf';
//# sourceMappingURL=Constants.js.map